// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bk7_","col":"styles_col__lkc7p","actions":"styles_actions__2ndXG","conflict":"styles_conflict__IvNNv"};